<template>
  <div>
    <div class="return-record-info">
      <crm-button
        v-if="contractAuth.costExport && contractAuth.costExport.toggleStatus"
        :buttonType="'plain'"
        :size="'mini'"
        :text="'导出'"
        class="fr mb10"
        @click="handleExportCost"
      >
      </crm-button>
      <crm-button
        v-if="contractAuth.costAdd && contractAuth.costAdd.toggleStatus"
        :size="'mini'"
        :text="'新增成本'"
        class="fr mb10"
        @click="handleAddCost"
      >
      </crm-button>
    </div>
    <el-table
      :data="compactCostData.results"
      :loading="costLoading"
      style="width: 100%; height: calc(100vh - 395px);"
    >
      <el-table-column prop="costAmount" label="成本(元)" align="center">
      </el-table-column>
      <el-table-column
        prop="costDate"
        label="产生日期"
        width="100"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="costTypeName" label="成本类型" align="center">
      </el-table-column>
      <el-table-column prop="payee" label="收款方" width="180" align="center">
      </el-table-column>
      <el-table-column
        prop="remarks"
        show-overflow-tooltip
        label="备注"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="createdName" label="创建人" align="center">
      </el-table-column>
      <el-table-column
        prop="gmtCreated"
        label="创建时间"
        width="180"
        align="center"
      >
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="contractAuth.costUpdate && contractAuth.costUpdate.toggleStatus"
            @click="handleUpdateCost(scope)"
            type="text"
            size="small"
          >
            编辑
          </el-button>
          <el-button
            v-if="contractAuth.costDel && contractAuth.costDel.toggleStatus"
            @click="handleDeleteCost(scope)"
            type="text"
            size="small"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="cost.pageNumber"
        :page-sizes="[5, 10, 20]"
        :page-size="cost.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="compactCostData.totalCount"
      >
      </el-pagination>
    </div>
    <!-- 新增成本弹窗 -->
    <el-dialog
      title="新增成本"
      :visible.sync="addCostDialogVisible"
      width="50%"
      append-to-body
    >
      <add-cost
        v-if="addCostDialogVisible"
        :compactId="id"
        @close="addCostDialogVisible = false"
        @success="handleRefreshCost()"
      >
      </add-cost>
    </el-dialog>
    <!-- 编辑成本弹窗 -->
    <el-dialog
      title="编辑成本"
      :visible.sync="updateCostDialogVisible"
      width="50%"
      append-to-body
    >
      <update-cost
        v-if="updateCostDialogVisible"
        :costDetail="costDetail"
        @close="updateCostDialogVisible = false"
        @success="handleRefreshCost()"
      >
      </update-cost>
    </el-dialog>
  </div>
</template>

<script>
import CrmButton from "~component/base/crmButton";
import { mapActions, mapGetters } from 'vuex'
import { newDownloadByUrl } from '@/scripts/utils'
import AddCost from "./AddCost.vue";
import UpdateCost from "./UpdateCost.vue";

export default {
  components: {
    CrmButton,
    AddCost,
    UpdateCost,
  },
  filters: {},
  props: {
    id: String,
  },
  data() {
    return {
      isDownload: false,
      addCostDialogVisible: false,
      updateCostDialogVisible: false,
      isRefresh: false,
      costLoading: false,
      costDetail: {},
      cost: {
        pageNumber: 1,
        pageSize: 5,
      },
    }
  },
  computed: {
    ...mapGetters({
      contractAuth: "authority/contractAuth",
      compactDetail: "compact/compactDetail",
      compactCostData: "compact/compactCostData",
    }),
  },
  watch: {},
  methods: {
    ...mapActions({
      getCompactDetail: "compact/getCompactDetail",
      getCompactCostList: "compact/getCompactCostList",
      deleteCompactCost: "compact/deleteCompactCost",
    }),
    handleSizeChange(value) {
      this.cost.pageNumber = 1
      this.cost.pageSize = value
      this.queryList()
    },
    handleCurrentChange(value) {
      this.cost.pageNumber = value
      this.queryList()
    },
    // 导出成本
    handleExportCost() {
      const url = `/api/crmcontract/download/cost?contractId=${this.id}`;
      this.handleDownloadRecord(url);
    },
    async handleDownloadRecord(url) {
      try {
        this.isDownload = true;
        this.notify = this.$notify({
          iconClass: "el-icon-loading",
          title: "",
          message: "正在导出中，请稍后...",
          duration: 0,
          showClose: false,
        });
        await newDownloadByUrl(url);
        this.notify.close();
      } catch (error) {
        this.notify.close();
        this.$message.error(error.message);
      }
      this.isDownload = false;
    },
    // 新增成本
    handleAddCost() {
      this.addCostDialogVisible = true;
    },
    // 更改了成本之后刷新数据
    handleRefreshCost() {
      this.queryList();
      this.isRefresh = true;
      this.getCompactDetail({ id: this.id });
    },
    queryList() {
      this.costLoading = true;
      const { pageSize, pageNumber } = this.cost;
      this.getCompactCostList({
        contractId: this.id,
        pageSize,
        pageNumber,
      }).finally(() => {
        if (this.compactCostData.results.length === 0 && pageNumber !== 1) {
          this.cost.pageNumber = 1;
          this.queryList();
        } else {
          this.costLoading = false;
        }
      });
    },
    // 删除成本
    handleDeleteCost(scope) {
      this.$confirm("是否确定删除该成本？", "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deleteCompactCost({ id: scope.row.id }).then(() => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.cost.pageNumber = 1
            this.handleRefreshCost();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 编辑成本
    handleUpdateCost(scope) {
      this.costDetail = scope.row;
      this.updateCostDialogVisible = true;
    },
  },
}
</script>
